export default __webpack_public_path__ + "static/media/portfolioImg_1.7ba88905.webp";